/**
 * City image paths mapping
 * Maps city slugs to their corresponding image paths on the CDN
 */
export const CITY_IMAGE_PATHS = {
  azrou: [
    "Destinations/Azrou/azrou.jpeg",
    "Destinations/Azrou/Azrou,centerfromhill.jpg",
    "Destinations/Azrou/Azrou_region.jpeg",
    "Destinations/Azrou/Photo Marcelo Singer - CRT -8064.jpg",
  ],
  boulemane: [
    "Destinations/Boulmane/Boulemane.jpg",
    "Destinations/Boulmane/Ruined_Kasbah_near_Boulmane_-_Dades_-_panoramio.jpeg",
  ],
  fes: [
    "Destinations/Fes/al attarine medersa fes.jpeg",
    "Destinations/Fes/Photo Marcelo Singer - CRT -5673.jpg",
    "Destinations/Fes/Photo Marcelo Singer - CRT -6072.jpg",
    "Destinations/Fes/Photo Marcelo Singer - CRT -6890.jpg",
  ],
  meknes: [
    "Destinations/Meknes/Moulay Driss.jpeg",
    "Destinations/Meknes/fabio-santaniello-bruun--rvMVeSZHZk-unsplash.jpg",
    "Destinations/Meknes/mouad-bouallayel-RfW_CKKk2Uo-unsplash.jpg",
  ],
  sefrou: ["Destinations/Sefrou/Sefrou,_region_fes.jpg"],
  taounate: [
    "Destinations/Taounate/Taounate_❤️.jpeg",
    "Destinations/Taounate/20141218_-_Barrage_Sahla_-_Morocco_-_Air_Photo_by_sebaso.jpeg",
    "Destinations/Taounate/La_retenue_du_barrage_sahla_A_taounate_1.jpeg",
  ],
  ifrane: [
    "Destinations/Ifrane/ifrane.jpeg",
    "Destinations/Ifrane/Photo Marcelo Singer - CRT -8146.jpg",
    "Destinations/Ifrane/amine-ozennou-wjOMf53cv88-unsplash (1).jpg",
    "Destinations/Ifrane/hamza-nouasria-WJD8XJGyPQ4-unsplash.jpg",
  ],
  "moulay-yaacoub": [
    "Destinations/Moulay Yaâcoub/Fes_moulay_yacoub_3.jpeg",
    "Destinations/Moulay Yaâcoub/8429958942_95279123ce_o.jpg",
    "Destinations/Moulay Yaâcoub/8429987496_6736726cec_o.jpg",
  ],
  elhajeb: [
    "Destinations/El hajeb/El_Hajeb_avenue_Hassan_II_(Maroc).jpeg",
    "Destinations/El hajeb/Panoramic_view_Ito.jpeg",
  ],
};

/**
 * Hero image paths
 * Images used in the hero slider on the home page and other pages
 */
export const HERO_IMAGE_PATHS = [
  "Photos Hero/al attarine medersa fes-min.jpeg",
  "Photos Hero/azrou-min.jpeg",
  "Photos Hero/ifrane-min.jpeg",
  "Photos Hero/Meknes-min.jpeg",
  "Photos Hero/Moulay Driss-min.jpeg",
  "Photos Hero/Volubilis-min.jpeg",
];

/**
 * Menu image paths
 * Images used in the CustomMenu component for the random background image
 */
export const MENU_IMAGE_PATHS = [
  "Photos Menu/photo menu-min.jpg",
  "Photos Menu/photo menu 2-min.jpg",
  "Photos Menu/photo menu 3-min.jpg",
  "Photos Menu/photo menu 4-min.jpg",
  "Photos Menu/photo menu 5-min.jpg",
  "Photos Menu/photo menu 6-min.jpg",
  "Photos Menu/photo menu 7-min.jpg",
  "Photos Menu/porte menu-min.jpg",
];

/**
 * Preference page category images
 * Images used for different preference categories/tags
 */
export const ACTIVITIES_IMAGE_PATHS = ["Activities/activity.jpg"];

export const NATURE_IMAGE_PATHS = [
  "Nature/nature1.jpeg",
  "Nature/nature2.jpeg",
  "Nature/nature3.jpg",
];

export const CULTURE_IMAGE_PATHS = [
  "Culture/culture1.jpg",
  "Culture/culture2.jpg",
  "Culture/culture3.jpg",
];

export const LACS_IMAGE_PATHS = [
  "Lacs/lac1.jpeg",
  "Lacs/lac2.jpg",
  "Lacs/lac3.jpg",
];

export const HISTORY_IMAGE_PATHS = [
  "History/history1.jpg",
  "History/history2.jpg",
  "History/history3.jpeg",
];

export const PICS_IMAGE_PATHS = [
  "pics/Photo Marcelo Singer - CRT -5499.jpg",
  "pics/Photo Marcelo Singer - CRT -6190.jpg",
  "pics/Photo Marcelo Singer - CRT -6749.jpg",
  "pics/Photo Marcelo Singer - CRT -7997.jpg",
  "pics/img5.JPG",
];
